<template>
  <div>
    <v-container>
      <div class="row">
        <div class="col-md-5 col-sm-5 col-xs-12">
          <v-carousel cycle>
            <!-- <v-carousel-item v-for="image of productDetail.images" :key="image.id"
              :src="image.original"
            > -->

            <v-carousel-item v-for="(image,index) of placeHolderSrc" :key="index"
              :src="image"
            >
<!--              <v-carousel-item-->
<!--                :src="require('../assets/img/home/slider4.jpg')"-->
<!--              >-->
            </v-carousel-item>
          </v-carousel>
        </div>
        <div class="col-md-7 col-sm-7 col-xs-12">
          <v-breadcrumbs class="pb-0" :items="breadcrums"></v-breadcrumbs>
          <div class="pl-6">
            <p class="display-1 mb-0">{{productDetail.title}}</p>
            <v-btn
              x-small
              color="secondary"
              dark
            >
              {{ availability.message }}
            </v-btn>
            <v-card-actions class="pa-0">
              <!-- <p class="headline font-weight-light pt-3">Ksh {{ totalPrice }}  <del style="" class="subtitle-1 font-weight-thin">$80.00</del></p> -->
              <p class="headline font-weight-light pt-3">Ksh {{ totalPrice }}</p>
              <v-spacer></v-spacer>
              <v-rating v-model="rating" class="" background-color="warning lighten-3"
                        color="warning" dense></v-rating>
              <span class="body-2	font-weight-thin"> 25 REVIEWS</span>
            </v-card-actions>
            <p class="body-1" v-html="productDetail.description">
            </p>
            <p class="title">SIZE</p>
            <v-radio-group v-model="row" row>
              <v-radio label="XS" value="XS"></v-radio>
              <v-radio label="S" value="s"></v-radio>
              <v-radio label="M" value="m"></v-radio>
              <v-radio label="L" value="l"></v-radio>
              <v-radio label="XL" value="xl"></v-radio>
            </v-radio-group>
            <p class="title">ITEMS</p>

            <v-text-field
                outlined
                style="width:100px"
                v-model="itemQuantity"
                type="number"
                :disabled="addToCartBtn"
                min="0"
                dense
            ></v-text-field>
            <v-btn class="primary white--text" outlined tile dense @click="addToCart" :disabled="addToCartBtn"><v-icon>mdi-cart</v-icon> ADD TO CART</v-btn>
            <v-btn class="ml-4" outlined tile>ADD TO WISHLIST</v-btn>
            <p class="" v-if="addToCartBtn">Out of stock</p>
          </div>
      </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-xs-12 col-md-12">
          <v-tabs>
            <v-tab >Description</v-tab>
            <v-tab>REVIEWS</v-tab>
            <v-tab-item>
              <p class="pt-10 body-1" v-html="productDetail.description">
              </p>
            </v-tab-item>
<!--            reviews-->
            <v-tab-item>
              <v-list
                three-line="true"
                avatar="true"
              >
                <v-list-item-group v-model="item" color="primary">
                  <v-list-item
                    v-for="(item, i) in items"
                    :key="i"
                    inactive="true"
                  >
                    <v-list-item-avatar>
                      <v-img :src="item.avatar"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="item.title"></v-list-item-title><v-rating v-model="rating" class="" background-color="warning lighten-3"
                                                                                           color="warning" dense></v-rating>
                      <v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-tab-item>
          </v-tabs>
          <v-card-text
            class="pa-0 pt-4"
            tile
            outlined
            v-if="recommendedProducts.length >= 1 "
          >
            <p class="subtitle-1 font-weight-light pt-3 text-center">YOU MIGHT ALSO LIKE</p>
            <v-divider></v-divider>
            <div class="row text-center">
              <div class="col-md-2 col-sm-4 col-xs-12 text-center" v-for="recommendedProd of recommendedProducts" :key="recommendedProd">
                <v-hover
                  v-slot:default="{ hover }"
                  open-delay="200"
                >
                  <v-card
                    :elevation="hover ? 16 : 2"
                  >
                    <app-product-card :url=recommendedProd></app-product-card>
                    <div class="text-center">
                      <v-btn
                        class="ma-2"
                        outlined
                        color="info"
                      >
                        Explore
                      </v-btn>
                    </div>
                  </v-card>
                </v-hover>
              </div>
            </div>
          </v-card-text>
        </div>
      </div>
      <ProductExists :display-dialog="productExists"/>
    </v-container>
   
  </div>
</template>
<script>
import axios from 'axios'
import ProductCard from "@/components/ProductCard";
import ProductExists from '@/components/Product/ProductExists'
    export default {
      components:{
        appProductCard: ProductCard,
        ProductExists
      },
      data: () => ({
            productDetail: '',
            productExists: false,
            recommendedProducts: '',
            itemQuantity: 1,
            totalPrice: '',
            availability: '',
            rating:4.5,
            breadcrums: [
                {
                    text: 'Home',
                    disabled: false,
                    href: 'breadcrumbs_home',
                },
                {
                    text: 'Clothing',
                    disabled: false,
                    href: 'breadcrumbs_clothing',
                },
                {
                    text: 'T-Shirts',
                    disabled: true,
                    href: 'breadcrumbs_shirts',
                },
            ],
            item: 5,
        // reviews
            items: [
                {
                    avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
                    title: 'Lorem ipsum dolor?',
                    subtitle: "<span class='text--primary'>Ali Connors</span> &mdash; Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Nisl tincidunt eget nullam non. Tincidunt arcu non sodales neque sodales ut etiam. Lectus arcu bibendum at varius vel pharetra. Morbi tristique senectus et netus et malesuada.\n" +
                        "\n",
                },
                {
                    avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
                    title: 'Lorem ipsum dolor <span class="grey--text text--lighten-1">4</span>',
                    subtitle: "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"
                },
                {
                    avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
                    title: 'Lorem ipsum dolor',
                    subtitle: "<span class='text--primary'>Sandra Adams</span> &mdash; Lorem ipsum dolor sit amet, consectetur adipiscing elit"
                },
                {
                    avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
                    title: 'Lorem ipsum dolor',
                    subtitle: ""
                },
                {
                    avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
                    title: 'Lorem ipsum dolor',
                    subtitle: "<span class='text--primary'>Britta Holt</span> &mdash; Lorem ipsum dolor sit amet, consectetur adipiscing elit"
                },
            ],
        }),
      created() {
          this.getProductDetail()
      },
      computed: {
        cartItems(){
          return this.$store.getters.cartItems
          },
        placeHolderSrc () {
          const placeHolderSrcChoices = [ 
                "https://images.unsplash.com/photo-1562157873-818bc0726f68?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8Y2xvdGhlc3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
                "https://images.unsplash.com/photo-1542060748-10c28b62716f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8Y2xvdGhlc3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
                "https://images.unsplash.com/photo-1434389677669-e08b4cac3105?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGNsb3RoZXN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
                "https://images.unsplash.com/photo-1537274942065-eda9d00a6293?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTZ8fGNsb3RoZXN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
                "https://images.unsplash.com/photo-1544441893-675973e31985?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjJ8fGNsb3RoZXN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
                "https://images.unsplash.com/photo-1479064555552-3ef4979f8908?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzR8fGNsb3RoZXN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
          ]
          const index = Math.floor(Math.random() * placeHolderSrcChoices.length);
          return placeHolderSrcChoices;
          },
          addToCartBtn(){
            return this.availability.message === 'Unavailable' ? true: false
          }
      },
      methods: {
      getProductDetail() {
        const productId = this.$route.params.prodId
        axios.get('products/' + productId + '/').then(res =>{
          this.recommendedProducts = res.data.recommended_products
          this.productDetail = res.data
          // console.log('Product detail', res.data)
          this.getProductPrice(res.data)
          this.showAvailability(res.data.availability)
        }).catch(error =>{
          console.log(error)
        })
      },
      getProductPrice(productInfo){
        axios.get(productInfo.price).then(res=>{
        this.totalPrice = res.data.incl_tax
      }).catch(error =>{
        console.log(error)
      })
    },
    showAvailability(availability) {
      axios.get(availability).then(res=>{    
      // console.log('availability', res.data)
      this.availability = res.data
      }).catch(error =>{
        console.log(error)
      })
    },
    addToCart(){
      const cartItemIndex = this.cartItems.findIndex((oldItem => oldItem.title == this.productDetail.title));
      if(cartItemIndex > -1){
        // ie it exists in the cart already
        this.productExists = true
      }else{
        const newPrice = this.totalPrice * this.itemQuantity
        const productDetail = { ... this.productDetail, price: this.totalPrice, quantity: this.itemQuantity, totalPrice: newPrice}
        this.$store.commit('addNewItem', productDetail)
      }
    }
      }
    }
</script>



// WEBPACK FOOTER //
// src/Views/ProductDetail.vue